import { createFeatureSelector, createSelector, Selector } from '@ngrx/store';
import { Dictionary } from '@ngrx/entity';

import * as fromState from './airplay-security-profile.state';
import * as fromReducer from './airplay-security-profile.reducer';

import { AppleAirPlaySecurityPreset } from '@rocksoft/mdm-sdk-v2';

export const selectAirplaySecurityProfileState: Selector<object, fromState.AirplaySecurityProfileState> =
  createFeatureSelector<fromState.AirplaySecurityProfileState>('airplaySecurityProfiles');

export const selectAirplaySecurityProfileIds: Selector<object, string[] | number[]> = createSelector(
  selectAirplaySecurityProfileState,
  fromReducer.selectAirplaySecurityProfileIds
);

export const selectAirplaySecurityProfileEntities: Selector<
  object,
  Dictionary<AppleAirPlaySecurityPreset>
> = createSelector(selectAirplaySecurityProfileState, fromReducer.selectAirplaySecurityProfileEntities);

export const selectAllAirplaySecurityProfiles: Selector<object, AppleAirPlaySecurityPreset[]> = createSelector(
  selectAirplaySecurityProfileState,
  fromReducer.selectAllAirplaySecurityProfiles
);

export const selectAllAirplaySecurityProfilesLoaded: Selector<object, boolean> = createSelector(
  selectAllAirplaySecurityProfiles,
  (settings) => settings && settings.length > 0
);
